export default "/images/06af75a6a61cf04d8d9c476e36bc92c3.png";